import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ErrorNotice, Loading } from '../PortalAluno/components/Feedback';
import StatusBadge from '../ReusableComponents/StatusBadge';
import { useIntegrationLog } from './hooks';

function JsonSection({ title, value, initiallyOpen = false }) {
    const [open, setOpen] = useState(initiallyOpen);
    return <section className="integration-log-json-section">
        <button type="button" className="integration-log-json-heading" onClick={() => setOpen(!open)} aria-expanded={open}>
            <strong>{title}</strong><span aria-hidden="true">{open ? '−' : '+'}</span>
        </button>
        {open && <pre>{JSON.stringify(value ?? null, null, 2)}</pre>}
    </section>;
}

export default function LogDetails({ log, onClose }) {
    const query = useIntegrationLog(log?.id);
    const audit = query.data?.data;
    return <Modal show={!!log} onHide={onClose} size="xl" centered scrollable className="integration-log-modal hidethis">
        <Modal.Header closeButton><Modal.Title>Detalhes da requisição</Modal.Title></Modal.Header>
        <Modal.Body>
            <ErrorNotice error={query.error} />
            {query.isLoading && <Loading />}
            {audit && <>
                <div className="integration-log-summary">
                    <StatusBadge variant="info">{audit.request.method}</StatusBadge>
                    <StatusBadge variant={audit.response.status >= 400 ? 'danger' : 'success'}>HTTP {audit.response.status}</StatusBadge>
                    <span>{audit.organization?.name || 'Sem identificação'}</span>
                    <code>{audit.request.url}</code>
                </div>
                <h3 className="module-details-title mt-4">Requisição</h3>
                <JsonSection title="Informações gerais" initiallyOpen value={{ id: audit.id, integration: audit.integration, recorded_at: audit.recorded_at, ip: audit.request.ip, duration_ms: audit.duration_ms, organization: audit.organization }} />
                <JsonSection title="Parâmetros de consulta" value={audit.request.query} />
                <JsonSection title="Headers da requisição" value={audit.request.headers} />
                <JsonSection title="Body da requisição" value={audit.request.body} />
                {audit.request.files && Object.keys(audit.request.files).length > 0 && <JsonSection title="Arquivos enviados (metadados)" value={audit.request.files} />}
                <h3 className="module-details-title mt-4">Resposta</h3>
                <JsonSection title="Headers da resposta" value={audit.response.headers} />
                <JsonSection title={audit.response.file ? 'Arquivo devolvido (metadados)' : 'Conteúdo da resposta'} value={audit.response.file || audit.response.body} />
            </>}
        </Modal.Body>
    </Modal>;
}
